import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const GoogleSlimOverviewGate = React.lazy(
  () => import("./GoogleSlimOverview.gate")
);

const GoogleSlimLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <GoogleSlimOverviewGate />
  </React.Suspense>
);

export default () => <GoogleSlimLoadable />;
